module.exports = __webpack_public_path__ + "20250721160708/img/stu_analysis.0dd5d27c.png";